import { render, staticRenderFns } from "./EnrollIcon.vue?vue&type=template&id=736a47de&"
import script from "./EnrollIcon.vue?vue&type=script&lang=js&"
export * from "./EnrollIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports